export const colors = ["#49C4E5", "#8471F2", "#67E2AE", "#EA5555", "#A8A4FF"];
